"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/use-hot-module-reload.cjs.ts
var use_hot_module_reload_cjs_exports = {};
__export(use_hot_module_reload_cjs_exports, {
  useHotModuleReload: () => useHotModuleReload
});
module.exports = __toCommonJS(use_hot_module_reload_cjs_exports);
var import_react = require("react");
var hasHMR = (() => {
  try {
    return Boolean(typeof module !== "undefined" && module.hot);
  } catch (err) {
    return false;
  }
})();
function useHotModuleReload(callback) {
  if (!hasHMR) {
    return void 0;
  }
  return useCJSHotModuleReload(callback);
}
function useCJSHotModuleReload(callback) {
  (0, import_react.useEffect)(() => {
    var _a;
    if (typeof module.hot === "undefined" || typeof ((_a = module.hot) == null ? void 0 : _a.addStatusHandler) !== "function") {
      return void 0;
    }
    const statusHandler = (status) => status === "idle" ? callback() : void 0;
    module.hot.addStatusHandler(statusHandler);
    return () => {
      var _a2;
      return (_a2 = module.hot) == null ? void 0 : _a2.removeStatusHandler(statusHandler);
    };
  }, [callback]);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useHotModuleReload
});
//# sourceMappingURL=use-hot-module-reload.cjs.js.map